module.exports = __webpack_public_path__ + "6f2007f76cc21b9115cad25f79e9e3e8.woff2";